import "./styles/index.css";

let bootPromise: Promise<void> | null = null;
let isReady = false;

function startApp() {
  if (!bootPromise) {
    document.documentElement.dataset.hydrated = "true";
    bootPromise = import("./bootstrap")
      .then(({ bootstrap }) => bootstrap())
      .then(() => {
        isReady = true;
      });
  }
  return bootPromise;
}

// The complete page is already present as static HTML. Load React on the first
// attempted interaction, replaying button clicks once handlers are attached.
// Ordinary links remain usable immediately through native browser navigation.
document.addEventListener(
  "click",
  (event) => {
    if (isReady) return;

    const target = event.target;
    const button = target instanceof Element ? target.closest("button") : null;
    if (!button) {
      void startApp();
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    void startApp().then(() => button.click());
  },
  { capture: true },
);

document.addEventListener("focusin", () => void startApp(), { once: true, capture: true });
window.addEventListener("scroll", () => void startApp(), { once: true, passive: true });

// Hydrate eventually even if the visitor only reads, while keeping startup work
// out of the critical rendering path on slower mobile devices.
window.setTimeout(() => void startApp(), 30_000);
